import {
   
    GET_COMMONTYPE_STARTED,   
    GET_COMMONTYPE_COMPLETED,
    GET_COMMONTYPE_FAILED,
    GETALL_COMMONTYPE_STARTED,   
    GETALL_COMMONTYPE_COMPLETED,
    GETALL_COMMONTYPE_FAILED,

} from '../actions/Commontype';

const intialCOMMONTYPEData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const COMMONTYPEData = (state = intialCOMMONTYPEData, action: any) => {
     
    switch (action.type) {
        case GET_COMMONTYPE_STARTED: 
        
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case GET_COMMONTYPE_COMPLETED:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case GET_COMMONTYPE_FAILED:
      return {
        ...state,
        isLoading: true,
      };
     

        default:
            return state;
    }
};
export const AllCOMMONTYPEData = (state = intialCOMMONTYPEData, action: any) => {
     
  switch (action.type) {
      case GETALL_COMMONTYPE_STARTED: 
      
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GETALL_COMMONTYPE_COMPLETED:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GETALL_COMMONTYPE_FAILED:
    return {
      ...state,
      isLoading: true,
    };
   

      default:
          return state;
  }
};